export const CHECKIOT = {
  USERCHECKIOT: 'user_check_iot',
  DEVICELIST: 'user_device_list',
  TEMPERATURE: 'user_temperature',
};
